import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import img1 from "../../assets/images/small/img-1.jpg";
import img2 from "../../assets/images/small/img-2.jpg";
import img3 from "../../assets/images/small/img-6.jpg";
import Webstories from "./Webstories";
import { Card, CardBody, Col } from "reactstrap";

const StoryPage = () => {




    return (

        <Col lg={4}>
            <Card className="p-0"
                style={{
                    backgroundColor: "#1E253A",
                    // borderRadius: "12px",
                }}>
                <CardBody style={{ padding: "0" }}>
                    <Webstories />
                </CardBody>
            </Card>
        </Col>

    );
};

export default StoryPage;
